import { SeoData } from 'utils/types/contentfulTypes';

import { SeoProps } from './';

export default function parseSeoData(
  seoData: SeoData | Queries.ContentfulSeo001,
): SeoProps {
  const faqSchema =
    seoData?.faqSchema?.map((faq) => ({
      question: faq?.question || '',
      answer: faq?.answer || '',
    })) || [];

  return {
    title: seoData?.metaTitle || '',
    description: seoData?.metaDescription?.metaDescription || '',
    keywords: seoData?.metaKeywords?.join(', ') || '',
    url: seoData?.canonicalUrl || '',
    canonicalUrl: seoData.canonicalUrl || '',
    noIndex: seoData?.metaKeywords?.includes('no-index') || false,
    faqSchema,
  };
}
